
 
<p>3. Map the file columns to the recipient list columns:</p>

<table class="mapping-column-table">
  <tr class="mapping-column-table-heading">
    <th style="padding-left:16px;" >Recipient list column</th>
    <th>File column</th>   
  </tr>
  <tr>
    <td class="mapping-column-table-first-td">Account ID</td>
    <td class="mapping-column-table-second-td">     
       <mat-form-field appearance="fill" oneEditableDropdown oneEditableDropdownSize="slim" class="import-drop-down">
      <input
        #triggercustID="matAutocompleteTrigger"
        [formControl]="frmctrlcustomerID"
        [matAutocomplete]="autocustID"
        matInput
        placeholder="Select a file column"
        type="text"
        (keydown)="onkeyDownEvent($event)"
      />
      <button        
        [disabled]="formDisabled"
        mat-flat-button
        matSuffix
        one-icon-button-flat
      >
        <mat-icon>{{ autocustID.isOpen ? 'collapse' : 'expand' }}</mat-icon>
      </button>
      <mat-autocomplete #autocustID="matAutocomplete">
        <mat-option *ngFor="let option of filteredOptionscustomerID | async" [value]="option" >
          {{ option }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field> 
  </td>
    
  </tr>
  <tr>
    <td class="mapping-column-table-first-td">Account name</td>
    <td class="mapping-column-table-second-td">
      <mat-form-field appearance="fill" oneEditableDropdown oneEditableDropdownSize="slim" class="import-drop-down">
        <input
          #triggercustomerName="matAutocompleteTrigger"
          [formControl]="frmctrlcustomerName"
          [matAutocomplete]="autocustomerName"
          matInput
          placeholder="Select a file column" 
          type="text"
          (keydown)="onkeyDownEvent($event)"         
        />
        <button          
          [disabled]="formDisabled"
          mat-flat-button
          matSuffix
          one-icon-button-flat
        >
          <mat-icon>{{ autocustomerName.isOpen ? 'collapse' : 'expand' }}</mat-icon>
        </button>
        <mat-autocomplete #autocustomerName="matAutocomplete">
          <mat-option *ngFor="let option of filteredOptionscustomerName | async" [value]="option">
            {{ option }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field> 
    </td>
   
  </tr>
  <tr>
    <td class="mapping-column-table-first-td">Account contact name</td>
    <td class="mapping-column-table-second-td">
      <mat-form-field appearance="fill" oneEditableDropdown oneEditableDropdownSize="slim" class="import-drop-down">
        <input
          #triggerFillSmall="matAutocompleteTrigger"
          [formControl]="frmctrlcustomerContactName"
          [matAutocomplete]="autoFillSmall"
          matInput
          placeholder="Select a file column"
          type="text"
          (keydown)="onkeyDownEvent($event)"
        />
        <button          
          [disabled]="formDisabled"
          mat-flat-button
          matSuffix
          one-icon-button-flat
        >
          <mat-icon>{{ autoFillSmall.isOpen ? 'collapse' : 'expand' }}</mat-icon>
        </button>
        <mat-autocomplete #autoFillSmall="matAutocomplete">
          <mat-option *ngFor="let option of filteredOptionscustomerContactName | async" [value]="option">
            {{ option }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </td>
   
  </tr>
  <tr>
    <td class="mapping-column-table-first-td">Account contact email</td>
    <td class="mapping-column-table-second-td">
      <mat-form-field appearance="fill" oneEditableDropdown oneEditableDropdownSize="slim" class="import-drop-down">
        <input
          #triggerFillSmall="matAutocompleteTrigger"
          [formControl]="frmctrlcustomerContactEmail"
          [matAutocomplete]="autoFillSmall"
          matInput
          placeholder="Select a file column"
          type="text"  
          (keydown)="onkeyDownEvent($event)"        
        />
        <button         
          [disabled]="formDisabled"
          mat-flat-button
          matSuffix
          one-icon-button-flat
        >
          <mat-icon>{{ autoFillSmall.isOpen ? 'collapse' : 'expand' }}</mat-icon>
        </button>
        <mat-autocomplete #autoFillSmall="matAutocomplete">
          <mat-option *ngFor="let option of filteredOptionscustomerContactEmail | async" [value]="option">
            {{ option }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>  
    </td>    
  </tr> 
</table>
